module.exports = __webpack_public_path__ + "static/media/Tax-Law.60ac5970.jpg";